/**
 * Escape a string for safe insertion into HTML (text or attribute values).
 * Use before passing user-controlled content to dangerouslySetInnerHTML
 * or when building HTML attribute values.
 * Escapes: & < > " '
 */
export function escapeHtml(s) {
  if (s == null || typeof s !== 'string') return '';
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
